import React, { useState } from 'react';
import Icon from '../../Icon/Icon';
import { stringifyFilter } from '../../../utils';
import { useGlobalValue } from '../../../state/GlobalProvider';
import { Link } from '../..';
import Format from '../../Format';
import { createLinkCard } from '../../../utils/routingUtils';
import styles from './SalesByCountryCard.module.sass';

const SalesByCountryCard = props => {
  const {
    data: cData,
    title,
    tabs,
    prefix,
    entity,
    filterColumn,
    currencyType = {}
  } = props || {};
  const [selected, setSelected] = useState(0);
  const items = cData && cData[selected] || [];
  const {
    i18n,
    locale,
    countries,
    params,
    proxy
  } = useGlobalValue();
  const {
    projectId,
    fiscalYear
  } = params;
  const totalPercentage = items.reduce((acc, {
    percentage
  }) => acc += percentage, 0);
  const {
    localeCurrency,
    currency
  } = currencyType;
  const list = items.map((item, index) => {
    const {
      name,
      value,
      percentage
    } = item;
    const filter = stringifyFilter([{
      "filters": [{
        value: name
      }],
      column: filterColumn ? filterColumn : "customer__billing_address_country"
    }]);
    const linkTo = `/${locale}/${projectId}/${fiscalYear}/${prefix}/${createLinkCard(null, null, {
      to: entity ? entity : 'invoices'
    }, params, {
      filter
    })}`;
    const itemName = `${index + 1} - ${countries.getName(name, locale) || name}`;
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: styles['list-item']
    }, linkTo ? /*#__PURE__*/React.createElement(Link, {
      className: styles['item-link'],
      to: linkTo,
      label: itemName
    }) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h5", null, itemName)), /*#__PURE__*/React.createElement("small", null, /*#__PURE__*/React.createElement(Format, {
      value: value,
      compact: "short",
      currency: currency,
      locale: localeCurrency
    })), /*#__PURE__*/React.createElement("h5", null, (percentage || 0).toFixed(2), "%"));
  });
  return /*#__PURE__*/React.createElement("div", {
    className: styles['root']
  }, /*#__PURE__*/React.createElement("div", {
    className: `widget-title ${styles['title-container']}`
  }, /*#__PURE__*/React.createElement(Icon, {
    className: styles['icon'],
    name: "top"
  }), /*#__PURE__*/React.createElement("h5", {
    className: styles['title']
  }, title), /*#__PURE__*/React.createElement("div", {
    className: styles['tabs']
  }, (tabs || []).map((tabName, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: `${styles['tab']} ${selected === index ? styles['is-selected'] : ''}`,
    onClick: () => {
      setSelected(index);
    }
  }, /*#__PURE__*/React.createElement("small", null, tabName))))), /*#__PURE__*/React.createElement("div", {
    className: styles['percentage-container']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['percentage']
  }, /*#__PURE__*/React.createElement("span", {
    className: styles['progress'],
    style: {
      width: `${totalPercentage}%`
    }
  })), /*#__PURE__*/React.createElement("strong", {
    className: styles['percentage-label']
  }, totalPercentage.toFixed(2), "%")), /*#__PURE__*/React.createElement("div", {
    className: styles['list']
  }, list));
};

export default SalesByCountryCard;